import { apiClient } from '../../app/api';
import type { BrandUpsertRequest, BrandView } from './types';

export function listBrands(): Promise<BrandView[]> {
  return apiClient.get<BrandView[]>('/admin/brands');
}

export function createBrand(payload: BrandUpsertRequest): Promise<BrandView> {
  return apiClient.post<BrandView>('/admin/brands', payload);
}

export function updateBrand(id: number, payload: BrandUpsertRequest): Promise<BrandView> {
  return apiClient.put<BrandView>(`/admin/brands/${id}`, payload);
}

export function deleteBrand(id: number): Promise<void> {
  return apiClient.delete<void>(`/admin/brands/${id}`);
}
